export const queryKeys = {
  chomesPayes: {
    all: ["chomesPayes"] as const,
    storeYear: (storeId: string | null, year: number) => [...queryKeys.chomesPayes.all, "storeYear", storeId, year] as const,
    employeeYear: (employeeId: string | null, year: number) =>
      [...queryKeys.chomesPayes.all, "employeeYear", employeeId, year] as const,
    validation: (storeId: string | null, year: number) => [...queryKeys.chomesPayes.all, "validation", storeId, year] as const,
    draft: (storeId: string | null, year: number) => [...queryKeys.chomesPayes.all, "draft", storeId, year] as const,
    /** Compteur de salariés actifs sans leurs 5 jours pour une année figée (alerte arrivants). */
    missingCount: (storeId: string | null, year: number) => [...queryKeys.chomesPayes.all, "missingCount", storeId, year] as const,
    /** Données planning manager : 5 jours publiés par salarié pour la semaine (une ou deux années civiles). */
    forPlanningWeek: (storeId: string | null, weekStartStr: string) =>
      [...queryKeys.chomesPayes.all, "forPlanningWeek", storeId, weekStartStr] as const,
    employeePlanningWeek: (storeId: string | null, employeeId: string | null, weekStartStr: string) =>
      [...queryKeys.chomesPayes.all, "employeePlanningWeek", storeId, employeeId, weekStartStr] as const,
  },
  employees: {
    all: ["employees"] as const,
    list: (storeId: string | null) => [...queryKeys.employees.all, "list", storeId] as const,
    active: (storeId: string | null) => [...queryKeys.employees.all, "active", storeId] as const,
    /** Salariés partiels + email (Suivi RH, accusés) — déduplique les requêtes entre hooks. */
    partialWithEmail: (storeId: string) => [...queryKeys.employees.all, "partialWithEmail", storeId] as const,
    /** Avenants d'horaire durable : rafraîchis avec les fiches, qu'ils datent. */
    weeklyHoursChanges: (storeId: string | null) => [...queryKeys.employees.all, "weeklyHoursChanges", storeId] as const,
    /** Salariés ayant un contrat en vigueur : rafraîchis avec les fiches (l'assistant contrat invalide « employees »). */
    currentContractIds: (storeId: string | null) => [...queryKeys.employees.all, "currentContractIds", storeId] as const,
    /** Rôles des comptes salariés (`get-employee-roles`) : invalidés avec la liste. */
    roles: (storeId: string | null) => [...queryKeys.employees.all, "roles", storeId] as const,
    /** Activation des comptes liés (`get_store_employee_activations`) : invalidée avec la liste. */
    activations: (storeId: string | null) => [...queryKeys.employees.all, "activations", storeId] as const,
  },
  interns: {
    all: ["interns"] as const,
    list: (storeId: string | null) => [...queryKeys.interns.all, "list", storeId] as const,
    byEmployee: (employeeId: string | null) => [...queryKeys.interns.all, "byEmployee", employeeId] as const,
  },
  serviceProviders: {
    all: ["serviceProviders"] as const,
    list: (storeId: string | null) => [...queryKeys.serviceProviders.all, "list", storeId] as const,
    byEmployee: (employeeId: string | null) => [...queryKeys.serviceProviders.all, "byEmployee", employeeId] as const,
  },
  storeSettings: {
    all: ["storeSettings"] as const,
    detail: (storeId: string | null) => [...queryKeys.storeSettings.all, storeId] as const,
  },
  subscriptionStatus: {
    all: ["subscriptionStatus"] as const,
    detail: (storeId: string | null) => [...queryKeys.subscriptionStatus.all, storeId] as const,
  },
  dashboardStats: {
    all: ["dashboardStats"] as const,
    detail: (storeId: string | null) => [...queryKeys.dashboardStats.all, storeId] as const,
  },
  schedules: {
    all: ["schedules"] as const,
    range: (storeId: string | null, startDate: string, endDate: string) =>
      [...queryKeys.schedules.all, storeId, startDate, endDate] as const,
    /** Vue jour timeline — chargée à la demande, distincte du cache semaine. */
    day: (storeId: string | null, dateStr: string) =>
      [...queryKeys.schedules.all, "day", storeId, dateStr] as const,
  },
  templates: {
    all: ["planningTemplates"] as const,
    list: (storeId: string | null) => [...queryKeys.templates.all, storeId] as const,
  },
  employeeDashboard: {
    all: ["employeeDashboard"] as const,
    week: (employeeId: string, weekStart: string) =>
      [...queryKeys.employeeDashboard.all, employeeId, weekStart] as const,
  },
  employeeLeaves: {
    all: ["employeeLeaves"] as const,
    list: (employeeId: string) => [...queryKeys.employeeLeaves.all, employeeId] as const,
  },
  employeeDocuments: {
    all: ["employeeDocuments"] as const,
    list: (employeeId: string) => [...queryKeys.employeeDocuments.all, "list", employeeId] as const,
    sharedContracts: (employeeId: string) =>
      [...queryKeys.employeeDocuments.all, "sharedContracts", employeeId] as const,
  },
  weeklyComments: {
    all: ["weeklyComments"] as const,
    detail: (storeId: string | null, weekStart: string) =>
      [...queryKeys.weeklyComments.all, storeId, weekStart] as const,
  },
  ownerSchedules: {
    all: ["ownerSchedules"] as const,
    range: (storeId: string | null, startDate: string, endDate: string) =>
      [...queryKeys.ownerSchedules.all, storeId, startDate, endDate] as const,
  },
  publications: {
    all: ["publications"] as const,
    week: (storeId: string | null, weekStart: string) =>
      [...queryKeys.publications.all, storeId, weekStart] as const,
  },
  storeInfo: {
    all: ["storeInfo"] as const,
    /** @deprecated — préférer `planning` ou `full` selon le besoin. Conservé pour invalidations larges. */
    detail: (storeId: string | null) => [...queryKeys.storeInfo.all, storeId] as const,
    /** Payload léger (owner_id, opening_hours) — utilisé par le planning. */
    planning: (storeId: string | null) => [...queryKeys.storeInfo.all, "planning", storeId] as const,
    /** Payload complet (nom, adresse, entreprise, etc.) — utilisé par /settings. */
    full: (storeId: string | null) => [...queryKeys.storeInfo.all, "full", storeId] as const,
  },
  ownerProfile: {
    all: ["ownerProfile"] as const,
    detail: (ownerId: string | null) => [...queryKeys.ownerProfile.all, ownerId] as const,
  },
  wizardCompleted: {
    all: ["wizardCompleted"] as const,
    detail: (userId: string | null) => [...queryKeys.wizardCompleted.all, userId] as const,
  },
  weeklyPlanningStatus: {
    all: ["weekly-planning-status"] as const,
    detail: (storeId: string | null) => ["weekly-planning-status", storeId] as const,
  },
  weekValidations: {
    all: ["week-validations"] as const,
    list: (storeId: string | null) => [...queryKeys.weekValidations.all, storeId] as const,
    detail: (validationId: string) => [...queryKeys.weekValidations.all, "detail", validationId] as const,
    /** Statuts des semaines d'un mois de paie (lignes à vérifier avant l'export). */
    weeks: (storeId: string | null, weekStarts: readonly string[]) =>
      [...queryKeys.weekValidations.all, "weeks", storeId, ...weekStarts] as const,
  },
  employeeTodo: {
    all: ["employeeTodo"] as const,
    items: (employeeId: string, subscriptionStatus: string) =>
      [...queryKeys.employeeTodo.all, "items", employeeId, subscriptionStatus] as const,
  },
  onboarding: {
    all: ["onboarding"] as const,
    progress: (userId: string | undefined) => [...queryKeys.onboarding.all, "progress", userId] as const,
    dismissed: (userId: string | undefined) => [...queryKeys.onboarding.all, "dismissed", userId] as const,
    autoDetect: () => [...queryKeys.onboarding.all, "auto-detect"] as const,
  },
  reportsData: {
    all: ["reports-data"] as const,
    detail: (storeId: string | null, month: number, year: number) =>
      [...queryKeys.reportsData.all, storeId, month, year] as const,
  },
  payrollHoursHistory: {
    all: ["payroll-hours-history"] as const,
    detail: (storeId: string | null, months: number) =>
      [...queryKeys.payrollHoursHistory.all, storeId, months] as const,
  },
  employeeSalaries: {
    all: ["employee-salaries"] as const,
    detail: (storeId: string | null) =>
      [...queryKeys.employeeSalaries.all, storeId] as const,
    chargedPayrollMass: (storeId: string | null, month: number, year: number) =>
      [...queryKeys.employeeSalaries.all, "charged-mass", storeId, month, year] as const,
    /** Masse chargée par mois pour une liste de mois sérialisée ("2026-1,2026-2,…"). */
    chargedPayrollMassByMonths: (storeId: string | null, monthsKey: string) =>
      [...queryKeys.employeeSalaries.all, "charged-mass-months", storeId, monthsKey] as const,
  },
  payrollPeriod: {
    all: ["dashboard-payroll-period"] as const,
    detail: (storeId: string | null, month: number, year: number) =>
      [...queryKeys.payrollPeriod.all, storeId, month, year] as const,
  },
  payrollRegularizations: {
    all: ["dashboard-regularizations"] as const,
    detail: (storeId: string | null, month: number, year: number) =>
      [...queryKeys.payrollRegularizations.all, storeId, month, year] as const,
  },
  leaveAttachments: {
    all: ["leaveAttachments"] as const,
    byRequest: (leaveRequestId: string) =>
      [...queryKeys.leaveAttachments.all, "byRequest", leaveRequestId] as const,
    byStoreToday: (storeId: string | null, dayKey: string) =>
      [...queryKeys.leaveAttachments.all, "byStoreToday", storeId, dayKey] as const,
    countByRequests: (storeId: string | null, ids: string[]) =>
      [...queryKeys.leaveAttachments.all, "countByRequests", storeId, ...ids] as const,
  },
  leaveRequests: {
    all: ["leaveRequests"] as const,
    pending: (storeId: string | null) => [...queryKeys.leaveRequests.all, "pending", storeId] as const,
    history: (storeId: string | null) => [...queryKeys.leaveRequests.all, "history", storeId] as const,
    /** Calendrier mensuel manager (/dashboard/conges) */
    managerMonth: (storeId: string, rangeStart: string, rangeEnd: string, refreshToken: number) =>
      [...queryKeys.leaveRequests.all, "managerMonth", storeId, rangeStart, rangeEnd, refreshToken] as const,
    /** Historique traité (approuvé / refusé / révoqué) */
    processedHistory: (storeId: string, since: string, limit: number, refreshToken: number) =>
      [...queryKeys.leaveRequests.all, "processedHistory", storeId, since, limit, refreshToken] as const,
  },
  /** Acceptations des CGV/CGU du compte connecté (bandeau des nouvelles conditions). */
  legalAcceptances: {
    all: ["legalAcceptances"] as const,
    mine: (userId: string | null) => [...queryKeys.legalAcceptances.all, "mine", userId] as const,
  },
  support: {
    all: ["support"] as const,
    activeForStore: (storeId: string | null) => [...queryKeys.support.all, "activeForStore", storeId] as const,
    mySessions: (userId: string | null) => [...queryKeys.support.all, "mySessions", userId] as const,
    pendingForStores: (storeIds: string[]) =>
      [...queryKeys.support.all, "pendingForStores", ...storeIds] as const,
    auditEvents: (userId: string | null) => [...queryKeys.support.all, "auditEvents", userId] as const,
    overview: () => [...queryKeys.support.all, "overview"] as const,
    activation: (filters: { minDays: number; includePending: boolean; search: string; page: number }) =>
      [...queryKeys.support.all, "activation", filters] as const,
    atRisk: (filters: { inactiveDays: number; search: string; page: number }) =>
      [...queryKeys.support.all, "atRisk", filters] as const,
    trialEnding: (filters: { daysAhead: number; search: string; page: number }) =>
      [...queryKeys.support.all, "trialEnding", filters] as const,
  },
  suiviRh: {
    all: ["suivi-rh"] as const,
    weekMatrix: (storeId: string | null, weekStart: string) =>
      [...queryKeys.suiviRh.all, "week-matrix", storeId, weekStart] as const,
    employeeTimeline: (storeId: string | null, weekStart: string, employeeId: string) =>
      [...queryKeys.suiviRh.all, "timeline", storeId, weekStart, employeeId] as const,
  },
  planningSigning: {
    all: ["planning-signing"] as const,
    week: (storeId: string | null, weekStart: string) =>
      [...queryKeys.planningSigning.all, storeId, weekStart] as const,
  },
  firmaEnvelopeQuota: {
    all: ["firma-envelope-quota"] as const,
    store: (storeId: string | null) => [...queryKeys.firmaEnvelopeQuota.all, storeId] as const,
  },
  /** Quota mensuel des signatures RH (contrats et avenants), distinct de celui des plannings. */
  hrFirmaEnvelopeQuota: {
    all: ["hr-firma-quota"] as const,
    store: (storeId: string | null | undefined) => [...queryKeys.hrFirmaEnvelopeQuota.all, storeId ?? null] as const,
  },
  paidLeave: {
    all: ["paid-leave"] as const,
    openings: (storeId: string | null) => [...queryKeys.paidLeave.all, "openings", storeId] as const,
    approvedStore: (storeId: string | null) => [...queryKeys.paidLeave.all, "approved", storeId] as const,
    employeeOpening: (employeeId: string | null) =>
      [...queryKeys.paidLeave.all, "opening", employeeId] as const,
    approvedEmployee: (employeeId: string | null) =>
      [...queryKeys.paidLeave.all, "approved-emp", employeeId] as const,
    approvalBundle: (storeId: string | null) => [...queryKeys.paidLeave.all, "bundle", storeId] as const,
    rulesGlobal: (storeId: string | null) => [...queryKeys.paidLeave.all, "rules-global", storeId] as const,
    rulesAbsence: (storeId: string | null) => [...queryKeys.paidLeave.all, "rules-absence", storeId] as const,
    scheduleAbsences: (storeId: string | null, start: string, end: string) =>
      [...queryKeys.paidLeave.all, "sched-abs", storeId, start, end] as const,
  },
  coverageModels: {
    all: ["coverageModels"] as const,
    list: (storeId: string | null) => [...queryKeys.coverageModels.all, "list", storeId] as const,
  },
  finance: {
    all: ["finance"] as const,
    target: (storeId: string | null, year: number) =>
      [...queryKeys.finance.all, "target", storeId, year] as const,
    actuals: (storeId: string | null, years: number[]) =>
      [...queryKeys.finance.all, "actuals", storeId, ...years] as const,
  },
  compteGestion: {
    all: ["compteGestion"] as const,
    entries: (storeId: string | null, year: number, month: number) =>
      [...queryKeys.compteGestion.all, "entries", storeId, year, month] as const,
    entriesYear: (storeId: string | null, year: number) =>
      [...queryKeys.compteGestion.all, "entriesYear", storeId, year] as const,
    monthSettings: (storeId: string | null, year: number, month: number) =>
      [...queryKeys.compteGestion.all, "monthSettings", storeId, year, month] as const,
    monthSettingsYear: (storeId: string | null, year: number) =>
      [...queryKeys.compteGestion.all, "monthSettingsYear", storeId, year] as const,
  },
  missions: {
    all: ["missions"] as const,
    catalogByStore: (storeId: string | null) =>
      [...queryKeys.missions.all, "catalog", storeId] as const,
    dayByStore: (storeId: string | null, dateStr: string) =>
      [...queryKeys.missions.all, "day", storeId, dateStr] as const,
    dayByEmployee: (employeeId: string | null, dateStr: string) =>
      [...queryKeys.missions.all, "employee", employeeId, dateStr] as const,
  },
};

